import { INavDropDownProps, IntermixLinkProps } from './types'

export const NavDropDown: React.FC<INavDropDownProps> = ({
    component,
    links,
    styles,
    onClose,
    name,
    email,
    initials,
}) => {
    const NavItemComponent = component

    return (
        <div
            className="flex flex-col content-end rounded-md border border-1 text-left"
            role="menu"
        >
            {(name || email) && (
                <div className="flex items-center gap-3 border-b border-gray-200 px-3 py-3 dark:border-gray-700">
                    <div className="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-full bg-primary font-semibold text-white">
                        {initials || '?'}
                    </div>
                    <div className="min-w-0">
                        {name && (
                            <div className="truncate text-sm font-semibold text-gray-900 dark:text-white">
                                {name}
                            </div>
                        )}
                        {email && (
                            <div className="truncate text-xs text-gray-500 dark:text-gray-400">
                                {email}
                            </div>
                        )}
                    </div>
                </div>
            )}
            <div className="flex flex-col px-1 py-1">
                {NavItemComponent &&
                    links.map(
                        ({
                            title,
                            path,
                            isAction,
                            icon,
                        }: IntermixLinkProps) => {
                            return (
                                <NavItemComponent
                                    title={title}
                                    key={title}
                                    styles={styles}
                                    path={path}
                                    isAction={isAction}
                                    icon={icon}
                                    preClick={() => onClose()}
                                />
                            )
                        },
                    )}
            </div>
        </div>
    )
}
